// @ts-nocheck
import * as React from "react"
import * as ReactDom from "react-dom"
import { checkLang } from "../services/general";
import Header from "../components/Header";
import Footer from "../components/Footer";

export const loadLayout = async () => {
	let { headerInfo, footerInfo } = checkResource()
	let langcode = checkLang()
	ReactDom.render(<Header linkList={headerInfo.linkList} sponsors={headerInfo.sponsors} lang={langcode}/>, document.getElementById('headerPage'))
	ReactDom.render(<Footer linkList={footerInfo.linkList} sponsors={footerInfo.sponsors} lang={langcode} socialNetwork={footerInfo.socialNetwork} subfooter={footerInfo.subfooter} />, document.getElementById('footerPage'))
	setNewsletterForm()
}

function checkResource(): { headerInfo: HeaderInterface, footerInfo: FooterInterface } {
	let headerInfo: HeaderInterface;
	let footerInfo: FooterInterface;

	let dataLayout = getDataLayout()

	let linkList = setPrefix(Object.values(dataLayout.information))
	let sponsors = Object.values(dataLayout.logos)
	let socialNetwork = Object.values(dataLayout.social)
	let subfooter = Object.values(dataLayout.subfooter)

	headerInfo = { linkList, sponsors }
	footerInfo = { linkList, sponsors, socialNetwork, subfooter }

	return { headerInfo, footerInfo }
}

function setPrefix(menuInfo) {
	let mainLang: string = menuInfo.some(menuItem => menuItem.url.includes('es')) ? 'es' : 'en';

	menuInfo.forEach((menuItem: any) => {
		if (!menuItem.url.includes(mainLang)) menuItem.url = `/${mainLang}${menuItem.url}`
	});
	
	return menuInfo;
}

function setNewsletterForm() {
	let refNewsletter = document.getElementById('refNewsletter')
	let refForm = document.getElementById('newsletterForm')
	refForm.insertAdjacentElement('beforeend', refNewsletter.children[0])
	refNewsletter.remove()
}

function getDataLayout(): JSON {
	let refDataElm = document.getElementById('dataHeader')
	refDataElm.remove()
	return JSON.parse(refDataElm.dataset.header)
}
